import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = {
  key: 0,
  class: "row g-4 mb-6"
}
const _hoisted_4 = { class: "col-6 col-lg-4 col-xl-3" }
const _hoisted_5 = { class: "card-title align-items-center mb-5" }
const _hoisted_6 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Your Inventory", -1)
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-150px" }, "Product"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-80px" }, "Remaining"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-160px" }, "Position"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "pe-4 min-w-150px" }, "Action")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("td", {
  colspan: "6",
  class: "text-center text-muted py-10"
}, "No inventory items found.", -1)
const _hoisted_13 = { class: "ps-4" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_16 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_17 = { class: "fw-semibold text-gray-800" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger fs-8"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" This product is ")
const _hoisted_20 = /*#__PURE__*/_createVNode("u", null, "NOT", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" PMA of the month. ")
const _hoisted_22 = { class: "fw-semibold text-gray-800" }
const _hoisted_23 = { class: "min-w-100px" }
const _hoisted_24 = { class: "min-w-160px" }
const _hoisted_25 = /*#__PURE__*/_createVNode("option", { value: "L" }, "Left", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "R" }, "Right", -1)
const _hoisted_27 = { class: "min-w-150px" }
const _hoisted_28 = { class: "pe-4" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 2,
  href: "javascript:void(0);",
  class: "btn btn-success btn-sm dashboardFontStyle mb-2"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_32 = {
  key: 4,
  href: "javascript:void(0);",
  class: "btn btn-warning btn-sm dashboardFontStyle mb-2"
}
const _hoisted_33 = {
  key: 6,
  href: "javascript:void(0);",
  class: "btn btn-primary btn-sm dashboardFontStyle mb-2"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_35 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_StatCard = _resolveComponent("StatCard")
  const _component_EstoreTabNavigator = _resolveComponent("EstoreTabNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_EstoreExpiry = _resolveComponent("EstoreExpiry")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_2, [
          (_ctx.pmawinsraffleticketcount != 0)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_StatCard, {
                    compact: "",
                    label: "PMA Wins Raffle Tickets",
                    icon: "media/icons/duotone/Shopping/Ticket.svg",
                    value: _ctx.pmawinsraffleticketcount,
                    "currency-symbol": "",
                    period: "",
                    decimals: 0
                  }, null, 8, ["value"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isOverriden)
            ? (_openBlock(), _createBlock(_component_EstoreTabNavigator, { key: 1 }))
            : _createCommentVNode("", true),
          _createVNode("h3", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
            ]),
            _hoisted_7
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("table", _hoisted_9, [
              _hoisted_10,
              _createVNode("tbody", null, [
                (_ctx.list.length === 0)
                  ? (_openBlock(), _createBlock("tr", _hoisted_11, [
                      _hoisted_12
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("span", _hoisted_15, [
                          _createVNode("span", _hoisted_16, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
                          ])
                        ]),
                        _createVNode("div", null, [
                          _createVNode("div", _hoisted_17, _toDisplayString(item.product), 1),
                          (item.isPMAOfTheMonth != 1)
                            ? (_openBlock(), _createBlock("div", _hoisted_18, [
                                _hoisted_19,
                                _hoisted_20,
                                _hoisted_21
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_22, _toDisplayString(Math.round(item.quantity)), 1)
                    ]),
                    _createVNode("td", _hoisted_23, [
                      _withDirectives(_createVNode("input", {
                        class: "seq-table-control seq-table-control--qty",
                        type: "text",
                        id: 'store_count_' + item.prodcode,
                        "onUpdate:modelValue": ($event: any) => (_ctx.store_count[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.store_count[index]]
                      ])
                    ]),
                    _createVNode("td", _hoisted_24, [
                      _withDirectives(_createVNode("select", {
                        class: "seq-table-control seq-table-control--pos",
                        id: 'pos_' + item.prodcode,
                        "onUpdate:modelValue": ($event: any) => (_ctx.pos[index] = $event)
                      }, [
                        _hoisted_25,
                        _hoisted_26
                      ], 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelSelect, _ctx.pos[index]]
                      ])
                    ]),
                    _createVNode("td", _hoisted_27, [
                      _withDirectives(_createVNode("input", {
                        class: "seq-table-control seq-table-control--usid",
                        type: "text",
                        id: 'tousid_' + item.prodcode,
                        "onUpdate:modelValue": ($event: any) => (_ctx.tousid[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.tousid[index]]
                      ]),
                      _createVNode("input", {
                        type: "hidden",
                        id: 'prodcode_' + item.prodcode
                      }, null, 8, ["id"])
                    ]),
                    _createVNode("td", _hoisted_28, [
                      (!_ctx.isOverriden)
                        ? (_openBlock(), _createBlock("div", _hoisted_29, [
                            (_ctx.isprocessing[index] === '0' && item.isPMAWins_Additional == 0)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 0);},
                                  class: "btn btn-success btn-sm dashboardFontStyle mb-2"
                                }, "Send (PMA)", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '0' && item.isPMAWins_Additional == 1)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 0);},
                                  class: "btn btn-info btn-sm dashboardFontStyle mb-2"
                                }, "Use (Raffle)", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '1')
                              ? (_openBlock(), _createBlock("a", _hoisted_30, "Processing..."))
                              : _createCommentVNode("", true),
                            _hoisted_31,
                            (_ctx.isprocessing[index] === '0' && item.isEasyVerseUpgrade_Product == 1)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 3,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 1);},
                                  class: "btn btn-warning btn-sm dashboardFontStyle mb-2"
                                }, "Upgrade", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '1' && item.isEasyVerseUpgrade_Product == 1)
                              ? (_openBlock(), _createBlock("a", _hoisted_32, "Processing..."))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '0' && 
                          (
                            //item.prodcode == 'C247U18' || item.prodcode == 'CPLU18' || item.prodcode == 'C2EU18' || item.prodcode == 'CPEU18' ||
                            //item.prodcode == 'CU18B10' || item.prodcode == 'CU18B25' || item.prodcode == 'CU18B100' || item.prodcode == 'CU18B150' || item.prodcode == 'CPU18B12' || item.prodcode == 'CPU18B48' || item.prodcode == 'CPU18B60'
                            item.isUSTrip_Product == 1
                          ) && 
                            _ctx.isShowUSTrip === 'true')
                              ? (_openBlock(), _createBlock("a", {
                                  key: 5,
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index, 2);},
                                  class: "btn btn-primary btn-sm dashboardFontStyle mb-2"
                                }, "US Trip", 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.isprocessing[index] === '1' && 
                          (
                            //item.prodcode == 'C247U18' || item.prodcode == 'CPLU18' || item.prodcode == 'C2EU18' || item.prodcode == 'CPEU18' ||
                            //item.prodcode == 'CU18B10' || item.prodcode == 'CU18B25' || item.prodcode == 'CU18B100' || item.prodcode == 'CU18B150' || item.prodcode == 'CPU18B12' || item.prodcode == 'CPU18B48' || item.prodcode == 'CPU18B60'
                            item.isUSTrip_Product == 1  
                          ) && 
                            _ctx.isShowUSTrip === 'true')
                              ? (_openBlock(), _createBlock("a", _hoisted_33, "Processing..."))
                              : _createCommentVNode("", true),
                            _hoisted_34,
                            _createVNode("button", {
                              type: "button",
                              class: "btn px-2 py-2",
                              "data-bs-toggle": "modal",
                              "data-bs-target": `#kt_modal_estore_expiry`,
                              onClick: ($event: any) => {_ctx.viewExpiryDate(item.prodcode,item.product);}
                            }, [
                              _createVNode("span", _hoisted_35, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/More.svg" })
                              ])
                            ], 8, ["onClick"]),
                            _createVNode(_component_EstoreExpiry, {
                              "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8",
                              pname: _ctx.modal_prodname,
                              list2: _ctx.expiry_list
                            }, null, 8, ["pname", "list2"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}